import { render } from "./ViewStudentCode.vue?vue&type=template&id=11b3b3af&scoped=true"
import script from "./ViewStudentCode.vue?vue&type=script&lang=js"
export * from "./ViewStudentCode.vue?vue&type=script&lang=js"

import "./ViewStudentCode.vue?vue&type=style&index=0&id=11b3b3af&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11b3b3af"]])

export default __exports__